import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

const BLOOD_VISION = 'BLOOD_VISION';

export const usBvRegionSwapPolicy: CartPolicy = (input, cart, meta) => {
  if (meta.store !== ShopifyStore.US || meta.createNewCart || !cart) {
    return pass(input);
  }

  const lines = input.lineItemsToAdd;
  if (!lines?.length) return pass(input);

  const incomingBv = lines.find(
    (line) => getAttr(line.attributes, '_product_type') === BLOOD_VISION,
  );
  const incomingExcRegion = getAttr(incomingBv?.attributes, '_exc_region');
  if (!incomingExcRegion) return pass(input);

  const conflicting = cart.lines.edges
    .filter((edge) => {
      if (getAttr(edge.node.attributes, '_product_type') !== BLOOD_VISION) {
        return false;
      }
      const existing = getAttr(edge.node.attributes, '_exc_region');
      return Boolean(existing) && existing !== incomingExcRegion;
    })
    .map((edge) => edge.node.id);
  if (!conflicting.length) return pass(input);

  const lineItemsToRemove = Array.from(
    new Set([...(input.lineItemsToRemove ?? []), ...conflicting]),
  );
  return {
    input: { ...input, lineItemsToRemove },
    reasons: ['BV region swap: remove conflicting region line(s)'],
  };
};
